import { ActionIcon, Group, Loader, Switch, Tooltip } from "@mantine/core";
import { IconCircleOff } from "@tabler/icons-react";
import { updateWarmup } from "../../../../../api/EmailAPI";
import { useEffect, useState } from "react";
import WarmupModal from "./WarmupModal";
import { IconTimeline } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";

const WarmupCell = ({ settings, row, apiRef }) => {
  const lang = useLanguage((s) => s.language);
  const [switching, setSwitching] = useState(false);
  const [enabled, setEnabled] = useState(!!settings?.warmup_enabled);
  const onSwitch = (e) => {
    e.stopPropagation();
    let newValue = e.target.checked;

    setSwitching(true);
    updateWarmup({ id: row.id, warmup_enabled: newValue })
      .then(() => setEnabled(newValue))
      .finally(() => setSwitching(false));
  };

  const [opened, setOpened] = useState(false);

  useEffect(() => {
    setEnabled(!!settings?.warmup_enabled);
  }, [settings?.warmup_enabled]);

  return (
    <>
      <Group
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Switch
          color="tertiary.8"
          onChange={onSwitch}
          checked={enabled}
          disabled={switching}
          thumbIcon={
            !row.write_permission ? (
              <IconCircleOff size={12} color="red" />
            ) : switching ? (
              <Loader type="oval" size={9} />
            ) : undefined
          }
        />

        <Tooltip label={lang.new_senders.warmup.button_tooltip}>
          <ActionIcon
            variant="light"
            size={"md"}
            onClick={(e) => {
              e.stopPropagation();
              setOpened(true);
            }}
          >
            <IconTimeline size={20} />
          </ActionIcon>
        </Tooltip>
      </Group>

      {opened && (
        <WarmupModal
          handleClose={() => setOpened(false)}
          row={row}
          apiRef={apiRef}
        />
      )}
    </>
  );
};

export default WarmupCell;
